import { render, staticRenderFns } from "./PopUpAnswerFile.vue?vue&type=template&id=4f77fcc4&scoped=true&"
import script from "./PopUpAnswerFile.vue?vue&type=script&lang=js&"
export * from "./PopUpAnswerFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpAnswerFile.vue?vue&type=style&index=0&id=4f77fcc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f77fcc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f77fcc4')) {
      api.createRecord('4f77fcc4', component.options)
    } else {
      api.reload('4f77fcc4', component.options)
    }
    module.hot.accept("./PopUpAnswerFile.vue?vue&type=template&id=4f77fcc4&scoped=true&", function () {
      api.rerender('4f77fcc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpAnswerFile.vue"
export default component.exports